import { ArrowLeftThin } from '@ori-ui/icons';
import { styled, Typography, Button } from '@ori-ui/mui';

export const StyledForm = styled('form')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  width: '100%',
  marginTop: theme.spacing(8),
}));

export const SubmitButtton = styled(Button)(({ theme }) => ({
  minWidth: '330px',
  marginTop: theme.spacing(3),
  order: 50,
}));

export const BackButtton = styled(Button)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  minWidth: '60px',
  marginTop: theme.spacing(2),
}));

export const StyledArrowIcon = styled(ArrowLeftThin)(({ theme }) => ({
  marginRight: theme.spacing(1),
}));

export const DocumentInfoWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '100%',
  justifyContent: 'flex-start',
  flexDirection: 'column',
  alignItems: 'flex-start',
}));

export const ConditionsInfoWrapper = styled('div')(({ theme }) => ({
  margin: theme.spacing(2, 0),

  [theme.breakpoints.up('sm')]: {
    marginTop: theme.spacing(6),
  },
}));

export const ConditionTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(4),
}));

export const PolicyText = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(1),
  textAlign: 'left',
}));

export const CollapseBox = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: '12px',
  fontWeight: 'bold',
  cursor: 'pointer',
}));

export const StyledLink = styled('a')(({ theme }) => ({
  color: theme.palette.text.primary,
  textDecoration: 'underline',
  '&:hover': {
    color: theme.palette.primary.light,
    textDecoration: 'underline',
  },
}));
